import { Component, computed, inject } from '@angular/core';
import { MenubarModule } from 'primeng/menubar';
import { MenuItem } from 'primeng/api';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { GraphUserService } from '../../services/auth/graph-user.service';
import { RoleService } from '../../services/auth/role.service';
import { AuthService } from '../../services/auth/auth.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [MenubarModule, TieredMenuModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  graphUserService = inject(GraphUserService);
  authService = inject(AuthService);
  roleService = inject(RoleService);

  items = computed<MenuItem[]>(() => {
    const hasWriteAccess = this.roleService.hasRole('Truth.Write');

    const menuItems: MenuItem[] = [
      {
        label: 'Home',
        routerLink: '/',
        routerLinkActiveOptions: { exact: true },
      },
      {
        label: 'Search',
        routerLink: '/search',
        routerLinkActiveOptions: { exact: true },
      },
    ];

    if (hasWriteAccess) {
      menuItems.push({
        label: 'Create',
        items: [
          {
            label: 'Authority Rule',
            routerLink: 'authority-rules/create',
            routerLinkActiveOptions: { exact: true },
          },
          {
            label: 'Business Standard',
            routerLink: 'business-standard/create',
            routerLinkActiveOptions: { exact: true },
          },
          {
            label: 'Subprocess',
            routerLink: 'subprocess/create',
            routerLinkActiveOptions: { exact: true },
          },
          {
            label: 'Controls',
            items: [
              {
                label: 'Report',
                routerLink: 'control-report/create',
                routerLinkActiveOptions: { exact: true },
              },
            ],
          },
          {
            label: 'Borrower Facing Communications',
            items: [
              {
                label: 'Letter',
                routerLink: 'borrower-facing-communications-letter/create',
                routerLinkActiveOptions: { exact: true },
              },
            ],
          },
          {
            label: 'Documentation',
            items: [
              {
                label: 'Procedure',
                routerLink: 'documentation/procedure/create',
                routerLinkActiveOptions: { exact: true },
              },
            ],
          },
        ],
      });
    }
    return menuItems;
  });

  profileItems = computed<MenuItem[]>(() => {
    return [
      {
        label: this.graphUserService.graphUser()?.displayName,
        items: [
          {
            label: 'Logout',
            command: () => {
              this.authService.logout();
            },
          },
        ],
      },
    ];
  });
}
